export default __webpack_public_path__ + "static/media/amaze-11.83f2620b.jpg";